<template>
    <div>

    </div>
</template>

<script>
export default {
    name : "overview"
}
</script>

<style lang="scss" scoped>

</style>
